var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.model)?_c('v-system-bar',{staticClass:"px-4",attrs:{"app":"","color":"#262626","dark":"","height":"58"}},[_c('v-spacer')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }